<template>
    <div class="addressPage" ref="addressPage">
        <XR-head titleText="选择区域" :rightShow="false" ref="head"></XR-head>
         <!--<mu-appbar class="XR-search-head" title="选择区域">
            <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>        
           <div slot="default" class="search-ctrl">
                <input  ref="search"  value="str" v-model="str" class="input-ctrl" placeholder="城市"  />          
            </div>
            <mu-flat-button v-on:click="goSearch" slot="right">搜索</mu-flat-button> 
        </mu-appbar>  -->
        <div class="search-content" v-show="view">
            <mu-list class="citychoose" v-if="searchCityList && searchCityList.length>0">
              <mu-list-item :title="city.area" @click="selectCity(city.fatherName,city.area,city.areaID)" class="quedincity" v-for="city in searchCityList" :key="city.areaID">
            </mu-list-item>    
            </mu-list>  
            <mu-list class="citychoose" v-else>
                <p style="padding:20px;">暂无数据</p>
            </mu-list>    
        </div>
        <div class="show1" v-if="!view">
            <div class="now">
            <mu-list-item class="districtChoose">
                <p class="cityShow">已选:{{city}}<span>{{county}}</span></p>
                <mu-raised-button slot="right" label="切换县区" labelPosition="before" @click="show = !show" :icon="':fa + fa-angle-' + (this.show==true?'down':'up')"/>
            </mu-list-item>  
            <div class="district" v-show="show && countyList.length>0">
                <mu-flat-button v-for="countyItem in countyList" :class="countyItem.area==county?'select':''" :key="countyItem.areaId" @click="selectCounty(countyItem.area,countyItem.areaID)">{{countyItem.area}}</mu-flat-button> 
            </div>
        </div>
        <div class="recent">
             <mu-list-item title="定位/最近访问">
                <template v-if="historyList.length>0">
                    <mu-flat-button v-for="historyItem in historyList" :key="historyItem.areaID" 
                    @click="selectCity(historyItem.province,historyItem.area,historyItem.areaID)" :class="historyItem.area==city?'active':''"><span v-if="historyItem.area==city"  class="fa fa-map-marker"></span>{{historyItem.area}}</mu-flat-button> 
                </template>
                <template v-else>
                    <mu-flat-button @click="selectCity('湖北省', '武汉市','420100')"><span class="fa fa-map-marker"></span>武汉市</mu-flat-button> 
                </template>
            </mu-list-item>  
        </div>
        <!-- <div class="hotcity">
             <mu-list-item title="热门城市 ">
                <mu-flat-button @click="selectCity('湖北省', '武汉市','420100')">武汉市</mu-flat-button> 
                <mu-flat-button @click="selectCity('北京','北京市','110100')">北京市</mu-flat-button>    
                <mu-flat-button @click="selectCity('上海', '上海市','310100')">上海市</mu-flat-button> 
                <mu-flat-button @click="selectCity('广东省', '深圳市','440300')">深圳市</mu-flat-button>     
                <mu-flat-button @click="selectCity('广东省', '广州市','440100')">广州市</mu-flat-button>   
                <mu-flat-button @click="selectCity('浙江省', '杭州市','330100')">杭州市</mu-flat-button> 
            </mu-list-item>  
        </div> -->
        <mu-list class="citychoose" v-if="cityList.length>0">
            <template v-for="py in cityList">
                <mu-list-item :title="py.Char" class="initials" :key="py.Char"></mu-list-item>
                <mu-list-item 
                    :title="city.area" class="quedincity" v-for="city in py.Citys" :key="city.Id" 
                    @click="selectCity(city.fatherName,city.area,city.areaID)">                                          
                </mu-list-item>                
            </template>
        </mu-list>
    </div>
        
    <XR-toast ref="XRtoast"></XR-toast>
</div>
</template>
<script>
export default {
    
  data () {
    return {
        show:false,
        str: '',
        view:false,
        cityList:[],
        city:'',
        countyList:[],
        county:'',
        searchkey:'',
        hasNoData:false,
        searchCityList:[],
        historyList:[],
        citiActive :false,
        citymap:false
    }
  },
  mounted(){
    this.readCache()
    this.getCityList()       
  },
  methods: {
    GoHistory(){
      this.$router.goBack()
    },
     goSearch(){
        this.getStr = this.str.toUpperCase().length;
        if(this.getStr>0){
            this.view=true
            const ths = this;
            this.$post("/Shop/BaseServer/GetAreaListByCityName",{ cityName:this.str})
            .then(function(res) {
                if (res.IsSuccess) {                
                    ths.searchCityList = res.Data                
                }
            })
            .catch(function(err) {
                console.log(err);
            });
        }
        else{
            this.$refs.XRtoast.failed('请输入城市名称',true)
            this.view=false
            console.log(this.view)
        }
     },
     
     getCityList(){
         this.cityList = [{"Char":"W","Citys":[{"id":1710,"areaID":"420100","area":"武汉市","father":"420000","fatherName":"湖北省","is_delete":false}]}]
        // const ths = this;
        // this.$post("/Shop/BaseServer/GetAllCityList")
        // .then(function(res) {
        //     if (res.IsSuccess) {
                
        //         ths.cityList = res.Data         
        //     }
        // })
        // .catch(function(err) {
        //     console.log(err);
        // });
     },
     selectCity(province,city,cityId){

        window.localStorage.ShopsPhysicalProductDetailDeliveryProvinceCache = province
        window.localStorage.ShopsPhysicalProductDetailDeliveryCityCache = city
        window.localStorage.ShopsPhysicalProductDetailDeliveryCityCodeCache = cityId
        
        var historyList = []
        var historyListJson =window.localStorage.ShopsPhysicalHistorySelectCityList
        if(historyListJson){
            historyList = JSON.parse(historyListJson)
        }      
        var newHistoryList = []  
        newHistoryList.push({province: province, area: city,areaID:cityId})
        for(var i=0; i< historyList.length;i++){
            if(newHistoryList.length>=3){                
                break
            }
            var cityItem = historyList[i]
            if(cityItem.area != city){
                newHistoryList.push(cityItem)
            }
        }
        window.localStorage.ShopsPhysicalHistorySelectCityList = JSON.stringify(newHistoryList)
        this.city = city
        
        this.$refs.addressPage.scrollTop = 0
        
        window.localStorage.removeItem('ProductDetailDeliveryAreaCache') 
        window.localStorage.removeItem('ProductDetailDeliveryAreaCodeCache') 
        this.county = ''

        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0

        this.view= false
        
     },
     selectCounty(county, countyId){
        window.localStorage.ShopsPhysicalProductDetailDeliveryAreaCache = county
        window.localStorage.ShopsPhysicalProductDetailDeliveryAreaCodeCache = countyId
         this.county = county
         this.show = true
        //  this.$router.push("/")
        this.GoHistory()
     },
     readCache(){
        var city = window.localStorage.ShopsPhysicalProductDetailDeliveryCityCache;
        if(city){
            this.city = city
        }
        var area = window.localStorage.ShopsPhysicalProductDetailDeliveryAreaCache;
        if(area){
            this.county = area
        }
        
        var historyList = window.localStorage.ShopsPhysicalHistorySelectCityList
        if(historyList){
            this.historyList = JSON.parse(historyList)
        }
     }
  },  
    watch:{
        city(){             
            const ths = this;
            this.$post("/Shop/BaseServer/GetAreaListByFatherName", {fatherName: this.city})
            .then(function(res) {
                if (res.IsSuccess) {
                    ths.countyList = res.Data      
                    ths.show = true         
                }
            })
            .catch(function(err) {
                console.log(err);
            });
        }
    }
}
</script>
<style>
.addressPage{
    background: #eee;
}
.addressPage .XR-search-head{
  height: 48px;
  text-align: center;
}
.addressPage .XR-search-head.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.addressPage .XR-search-head .mu-appbar-title {
  font-size: 16px;
}
.addressPage .XR-search-head .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.addressPage .XR-search-head .title .title-text {
  margin: 0;
  line-height: 48px;
}


.addressPage .XR-search-head .search-ctrl{
  height: 32px;
  line-height: 32px;
  border-radius: 25px;
  padding-right: 10px;
  color:#ccc;
  background: #999;
  overflow: hidden;
}
.addressPage .XR-search-head .search-ctrl .input-ctrl{
  float: left;
  line-height: 32px;
  font-size: 12px;
  width: 90%;
  padding-left: 12px;
  background: inherit;
  border: none;
  outline :none;
  text-align: left;
  color:white;
}
.addressPage .XR-search-head .search-ctrl .icon-ctrl{
  width: 10%;
  float: right;
  line-height: 28px;
  text-align: right;
  color:#ccc;
}
.addressPage .now{
    background:#fff;
}
.addressPage .now .districtChoose .mu-item-content mu-text{
    font-weight: bold;
}
 
.addressPage .now .districtChoose .mu-item-right{
    width: 80px;
}
.addressPage .now .districtChoose .mu-item-right .mu-raised-button{
    box-shadow: none;
    font-size: 12px;
}
.addressPage .now .districtChoose .mu-item-right  .mu-raised-button-wrapper{
    padding: 0;
}
.addressPage .now .districtChoose .mu-item-right  .mu-raised-button-wrapper .fa-angle-down,.addressPage .now .districtChoose .mu-item-right  .mu-raised-button-wrapper .fa-angle-up{
    font-size: 12px;
}
.addressPage .now .districtChoose .mu-item-right  .mu-raised-button-wrapper .mu-raised-button-label{
    padding: 0;
}
.addressPage .now .district{
    padding: 0 16px 32px;
}
.addressPage .now .district .mu-flat-button{
    font-size: 14px;
    border: 1px solid #eee;
    min-width: 25%;
    margin-top: 16px;
    margin-right: 7%;
}

.addressPage .now .recent .mu-item-content mu-text{
    font-weight: bold;
}
 
.addressPage .now .recent .mu-item-right{
    width: 80px;
}
.addressPage .now .recent .mu-item-right .mu-raised-button{
    box-shadow: none;
    font-size: 12px;
}
.addressPage .now .recent .mu-item-right  .mu-raised-button-wrapper{
    padding: 0;
}
.addressPage .now .recent .mu-item-right  .mu-raised-button-wrapper .fa-angle-down,.addressPage .now .districtChoose .mu-item-right  .mu-raised-button-wrapper .fa-angle-up{
    font-size: 12px;
}
.addressPage .now .zz .mu-item-right  .mu-raised-button-wrapper .mu-raised-button-label{
    padding: 0;
}
.addressPage .now .district{
    padding: 0 16px 32px;
}
.addressPage .now .district .mu-flat-button{
    font-size: 14px;
    border: 1px solid #eee;
    min-width: 25%;
    margin-top: 16px;
    margin-right: 7%;
}
.addressPage .recent .mu-item-content .mu-item-title{
    font-size: 14px;
    color: #999;
    font-weight: bold;
}
.addressPage .recent .mu-item-content .mu-flat-button{
    min-width: 25%;
    margin-right: 7%;
    margin-top: 16px;
    border: 1px solid #ccc;
}
.addressPage .hotcity{
    border-bottom: 1px solid #ccc;
}
.addressPage .hotcity .mu-item-content .mu-item-title{
    font-size: 14px;
    color: #999;
    font-weight: bold;
}
.addressPage .hotcity .mu-item-content .mu-flat-button{
    min-width: 25%;
    margin-right: 7%;
    margin-top: 16px;
    border: 1px solid #ccc;
}
.addressPage .citychoose{
    background: #fff;
    padding-top:0 ;
}
.addressPage .number p{
    font-size: 12px;;
}
.addressPage .citychoose .initials{
    background: #eee;
}
.addressPage .citychoose .quedincity{
    border-bottom: 1px solid #ccc;
}
.addressPage .citychoose .quedincity:last-child{
    border: 0;
}
.addressPage .number{
    position: fixed;
    right: 0;
    top: 120px;
    background: #fff;
    width: 20px;
    text-align: center;
    opacity: 0.6;
}
.addressPage .show1 .now .select{
    border-color: #ff4981;
    color:#ff4981;
}
.addressPage .recent .active .fa-map-marker{
    color: #ff4981;
    padding-right: 5px; 
}
.addressPage .recent .mu-flat-button .fa-map-marker{
    color: #ff4981;
    padding-right: 5px; 
}
.addressPage .show1 .districtChoose .mu-item-content{
    width: 80%;
}
.addressPage .show1 .districtChoose .mu-item-content .cityShow{
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
</style>




// WEBPACK FOOTER //
// src/pages/shangquan/sqaddress.vue